class JobDetailsDTO {
    constructor(data) {
        this.jobDetailId=data.jobDetailId;
        this.jobCode = data.jobCode;
        this.jobTitle = data.jobTitle;
        this.numberOfPositions = data.numberOfPositions;
        this.departmentId = data.departmentId;
        this.companyId = data.companyId;
        this.accountId = data.accountId;
        this.clientAccountManagerName = data.clientAccountManagerName;
        this.clientAccountManagerEmailId = data.clientAccountManagerEmailId;
        this.clientAccountManagerPhoneNo = data.clientAccountManagerPhoneNo;
        this.employmentTypeId = data.employmentTypeId;
        this.workMode = data.workMode;
        this.billability = data.billability;
        this.experienceInYears = data.experienceInYears;
        this.experienceInMonths = data.experienceInMonths;
        this.workingHours = data.workingHours;
        this.fulfillmentDate = data.fulfillmentDate;
        this.priority = data.priority;
        this.recruiterId = data.recruiterId;
        this.accountManagerId = data.accountManagerId;
        this.approvalNeeded = data.approvalNeeded;
        this.notes = data.notes;
        this.jobDescription = data.jobDescription;
        this.createdByUserId = data.createdByUserId;
        this.createdAt = data.createdAt;
        this.recordStatus=data.recordStatus;
        this.qualificationIds = data.qualificationIds || [];
        this.skillIds= data.skillIds || [];
        this.approverIds= data.approverIds || [];
        this.ownerIds= data.ownerIds || [];
        this.panelUserIds= data.panelUserIds || [];
        this.firstName=data.firstName;
        this.lastName=data.lastName;
        this.departmentName=data.departmentName;
        this.companyName=data.companyName;
        this.accountName=data.accountName;
        this.totalRecords=data.totalRecords;
        this.jobStatus=data.jobStatus;
        this.filledPositions=data.filledPositions;
        this.approverNames = data.approverNames;
        this.ownerNames=data.ownerNames;
        this.createdbyusername=data.createdbyusername;
        this.companyNames=data.companyNames;
        this.accountManagerNames=data.accountManagerNames;
        this.panelUserNames=data.panelUserNames;
        this.recruiterNames=data.recruiterNames;
        this.skillNames=data.skillNames;
        this.educationalQualificationNames=data.educationalQualificationNames;
        this.employmentTypeName=data.employmentTypeName;
        this.locationIds= data.locationIds || [];
    }
}

module.exports = JobDetailsDTO;